<template>
  <div
    class="hm-noticebar fixedBottom"
    :class="className"
    :style="{ backgroundColor, color }"
  >
    <div class="hm-noticebar__content" :class="setContenClass">
      <div
        v-if="showIcon === 'true' || showIcon === true"
        class="hm-noticebar__content-icon flex item-center"
        :class="className"
        :style="{ backgroundColor, color, borderRight: 'none' }"
      >
        <img style="width: 35px" :src="iconImage" v-if="iconImage" />
        <span v-else class="hmicon icon-gonggao"></span>
      </div>
      <div class="hm-noticebar__content-text" :class="setTextClass">
        <div
          class="hm-noticebar__content-inner"
          :id="elId"
          :style="{
            'animation-duration': animation,
            '-webkit-animation-duration': animation
          }"
        >
          <span :class="{titleBold}">{{ text }}</span>
        </div>
        <div
          class="hm-noticebar__content-inner"
          :id="elId"
          :style="{ animation, '-webkit-animation': animation }"
          v-if="scrollable"      
        >
          <span :class="{titleBold}">{{ text }}</span>
        </div>
      </div>
      <div class="hm-noticebar__content-more hm-noticebar-botton" v-if="isShowClickButton">
        {{clickButtonTitle}}
      </div>
      <div class="hm-noticebar__close" v-if="isShowCloseButton">X</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    text: String,
    moreText: String,
    backgroundColor: {
      type: String,
      default: "#fffbe8"
    },
    speed: {
      //默认1s滚动100px
      type: [String, Number],
      default: 100
    },
    color: {
      type: String,
      default: "#de8c17"
    },
    single: {
      //是否单行
      type: [String, Boolean],
      default: true
    },
    scrollable: {
      //是否滚动，添加后控制单行效果取消
      type: [String, Boolean],
      default: false
    },
    showIcon: {
      //是否显示左侧icon
      type: [String, Boolean],
      default: true
    },
    iconImage: {
      //是否显示左侧icon
      type: [String, Boolean],
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    fixedBottom:{
      type: Boolean,
      default: false
    },
    isShowClickButton:{
      type: Boolean,
      default: false
    },
    clickButtonTitle:{
      type: String,
      default: ""
    },
    hrefAddress:{
      type: String,
      default: ""
    },
    isShowCloseButton:{
      type: Boolean,
      default: false
    },
    textCenter:{
      type: Boolean,
      default: false
    },
    titleBold:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const elId = `hm_${Math.ceil(Math.random() * 10e5).toString(36)}`;
    return {
      elId: elId,
      animation: ""
    };
  },
  watch: {
    text() {
      this.$nextTick(() => {
        setTimeout(this.setAnimation, 200);
      });
    }
  },
  computed: {
    setTextClass() {
      let classList = [];
      if (this.scrollable === true || this.scrollable === "true") {
        classList.push("hm-noticebar--scrollable");
      } else {
        if (this.single === "true" || this.single === true || this.moreText || this.scrollable === false) {
          classList.push("hm-noticebar--single");
        }
      }
      if(!this.scrollable && this.textCenter){
        classList.push(" textCenter");
      }
      return classList;
    },
    setContenClass() {
      let classList = [];
      if (
        this.scrollable === true ||
        this.scrollable === "true" ||
        this.single === "true" ||
        this.single === true ||
        this.moreText
      ) {
        classList.push("hm-noticebar--flex");
      }
      return classList;
    }
  },
  mounted() {
    this.setAnimation();
  },
  onReady() {
    this.setAnimation();
  },
  // #endif
  methods: {
    setAnimation() {
      if (this.scrollable === false || this.scrollable === "false") {
        return;
      }
      setTimeout(() => {
        const width =
          document.body.getBoundingClientRect().width -
          document
            .querySelector(".hm-noticebar__content-icon")
            .getBoundingClientRect().width;
        this.animation = `notice ${width / this.speed}s linear infinite both`;
      }, 200);
    }
  }
};
</script>

<style>
@charset "UTF-8";

.hm-noticebar {
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  justify-content: left;
}
.hm-noticebar__close {
  color: #DB914C;
  margin-right: 12px;
  margin-left: 12px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.hm-noticebar__content {
  position: relative;
  flex: 1;
  overflow: hidden;
  /* height: 38px; */
}
.gradient {
  background-image: linear-gradient(
    to right,
    transparent 10px,
    #3368e2,
    transparent
  ) !important;
}
.hm-noticebar__content.hm-noticebar--flex {
  flex: 1;
  display: flex;
  flex-direction: row;
}
.hm-noticebar__content-icon {
  display: inline-block;
  z-index: 1;
  padding: 0 15px;
  margin: 8px 0;
  border-right-width: 1px;
  border-right-style: solid;
}
.hm-noticebar__content-more {
  width: 90px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  justify-content: flex-end;
  word-break: keep-all;
  margin-left: 10px;
  color: #999;
}
.hm-noticebar__content-more-text {
  font-size: 12px;
  white-space: nowrap;
}
.hm-noticebar__content-text {
  word-break: break-all;
  line-height: 1.5;
  display: inline;
}
.hm-noticebar__content-text.hm-noticebar--single {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
  line-height: 34px;
}
.hm-noticebar__content-text.hm-noticebar--scrollable {
  flex: 1;
  display: block;
  overflow: hidden;
}
.hm-noticebar__content-text.hm-noticebar--scrollable
  .hm-noticebar__content-inner {
  /* position: absolute;
  top: 50%; */
  padding-left: 100%;
  white-space: nowrap;
  display: inline-block;
  /* #ifdef H5 */
  animation-name: notice;
  animation-timing-function: linear;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  /* #endif */
  transform: translate3d(0, -50%, 0);
  /* transform: translateZ(0); */
}
.hm-noticebar__content-inner {
  font-size: 12px;
  display: inline;
}
@keyframes notice {
  100% {
    transform: translate3d(-100%, -50%, 0);
  }
}
.hm-noticebar-botton{
  height: 30px;
  line-height: 30px;
  background: linear-gradient(90deg, #E9B57C 0%, #D98C46 100%);
  box-shadow: inset 0px -4px 4px 0px rgba(0,0,0,0.03);
  border-radius: 30px;
  text-align: center;
  width: auto;
  color: #FFFFFF;
  padding: 0 10px;
  margin-top: 3px;
  margin-right: 3px;
}
.textCenter{
  text-align: center;
  width:100%;
  line-height: 34px;
}
.titleBold{
  font-size: 14px;
  font-weight: bold;
}
</style>
